import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=5153f22e"
import script from "./panel.vue?vue&type=script&lang=js"
export * from "./panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports